export default {
  translationState: (state) => {
    return state.enableTranslation
  },
  activeTranslationInfo: (state) => {
    return state.activeTranslationInfo
  },
}
